import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import { getDeviceType, serviceErrorToAnalyticsFormat } from './DigitalAnalyticsHelper';

export class PhoneVerificationActionFilter extends BaseActionFilter {
    getPhoneVerificationFormErrorDL(error = {}) {
        const getCancelOrderFormErrorDL = this.getFormErrorDL(serviceErrorToAnalyticsFormat(error));
        return getCancelOrderFormErrorDL;
    }

    getPhoneVerificationPageLoad(store) {
        const { context } = store.getState();
        const deviceType = getDeviceType(context);
        const pageName = 'account';
        const phoneVerificationSliderDL = this.updateCommonDigitalData();

        phoneVerificationSliderDL.page.pageInfo.pageName = 'phone verification slider';
        phoneVerificationSliderDL.page.pageInfo.pageType = pageName;
        phoneVerificationSliderDL.page.pageInfo.siteSection = pageName;
        phoneVerificationSliderDL.page.pageInfo.deviceType = deviceType;
        phoneVerificationSliderDL.page.pageInfo.searchRedirect = '';
        phoneVerificationSliderDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        phoneVerificationSliderDL.page.pageInfo.version = 'apollo 1 yoda cam slider';
        phoneVerificationSliderDL.page.category = {};
        phoneVerificationSliderDL.page.category.primaryCategory = pageName;
        phoneVerificationSliderDL.page.category.subCategory1 = '';
        phoneVerificationSliderDL.page.category.subCategory2 = '';
        phoneVerificationSliderDL.page.category.department = pageName;
        phoneVerificationSliderDL.error = [
            {
                errorDescription: '',
            },
        ];

        return phoneVerificationSliderDL;
    }
}

export default PhoneVerificationActionFilter;
